import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import { AsyncButton, SaveStates, VideoInput } from '@infl-ts/ui-advocate-components';
import { useMutationMapper } from '@infl-ts/util-use-mutation-mapper';
import * as E from 'fp-ts/Either';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import StageLayout from '../stage-layout';
import { jsx as _jsx } from "react/jsx-runtime";

var VideoUpload = function VideoUpload(_ref) {
  var stage = _ref.stage,
      activity = _ref.activity,
      completeStage = _ref.completeStage,
      completeStageStatus = _ref.completeStageStatus,
      prospect = _ref.prospect;
  var questionId = stage.id;
  var videoForm = useForm({
    defaultValues: _defineProperty({}, questionId, null)
  });
  useEffect(function () {
    videoForm.reset(_defineProperty({}, questionId, null));
  }, [stage.id]);
  var Saving = SaveStates.Saving,
      Default = SaveStates.Default,
      Success = SaveStates.Success,
      Error = SaveStates.Error;
  var mutationValue = useMutationMapper(completeStageStatus, function (_ref2) {
    var completeStage = _ref2.completeStage;
    return completeStage.__typename === 'CompleteStageErrors' ? E.left(completeStage) : E.right(completeStage);
  }, [Saving, Success, Error, Default]);
  return /*#__PURE__*/_jsx(StageLayout, {
    showPublicResponseMessage: true,
    stage: stage,
    prospect: prospect,
    actions: /*#__PURE__*/_jsx(AsyncButton, {
      status: mutationValue,
      onClick: videoForm.handleSubmit(function (_ref3) {
        var file = _ref3[questionId];
        // Disabled rule since Filestack already catches the case of file being undefined,
        // prevents the completeStage from firing and shows the error to the user
        // eslint-disable-next-line  @typescript-eslint/no-non-null-assertion
        if (!file) return;
        var url = file.url,
            handle = file.handle;
        return completeStage({
          videoUploadInput: {
            stageID: stage.id,
            activityID: activity === null || activity === void 0 ? void 0 : activity.id,
            file: {
              url: url,
              filestack: {
                handle: handle
              }
            }
          }
        });
      }),
      text: ['Submitting...', 'Saved', stage.completionText || 'Next', stage.completionText || 'Next']
    }),
    "data-element": "StageLayout",
    "data-component": "VideoUpload",
    "data-source-file": "index.tsx",
    children: /*#__PURE__*/_jsx(VideoInput, {
      name: questionId,
      required: true,
      questionForm: videoForm,
      "data-element": "VideoInput",
      "data-component": "VideoUpload",
      "data-source-file": "index.tsx"
    })
  });
};

export default VideoUpload;